import React from "react";
import Avatar from "js/components/shared/Avatar";
import { userDisplayText } from "js/utils/userUtils";
import PropTypes from "prop-types";

const StudentRow = ({ student, onSelect, thread, threadKey, hasUnreadMessages }) => {
	if (!student) {
		return null;
	}

	const handleSelect = () => {
		// If thread object is not found, still pass the threadKey as fallback
		onSelect(student.username, thread?.threadKey ?? threadKey);
	};

	return (
		<button className="ClassroomChatroom_rowContainer" onClick={handleSelect} type="button">
			<div className="Classroom_rowWrapper">
				<Avatar />
				<div className="ClassroomChatroom_student">
					<div className="ClassroomChatStudentsList_name">{userDisplayText(student)}</div>
					<div className="ClassroomChatStudentsList_message">{!!thread.message ? thread.message : "No Messages"}</div>
				</div>
				{!!hasUnreadMessages && (
					<div className="ClassroomChat_notificationsContainer">
						<div className="ClassroomChat_notificationsValue"></div>
					</div>
				)}
			</div>
		</button>
	);
};

StudentRow.defaultProps = {
	thread: {},
};

StudentRow.propTypes = {
	student: PropTypes.object,
	onSelect: PropTypes.func,
	thread: PropTypes.object,
	threadKey: PropTypes.string,
	hasUnreadMessages: PropTypes.bool,
};

export default StudentRow;
